export const supplies = {
	pageTitle: "Inputs",
	pageDescription:
		"Inputs are all the materials that are used for the production of a certain product or in the creation of another input. On this screen, it is possible to register and view all registered inputs in one place.",
	searchPlaceholder: "Search inputs",
	formErrors: {
		supplyName: "Supply name must be filled in",
		conversionRule: "Conversion rule values must be filled in",
	},
	table: {
		name: "Name",
		productionRule: "Recipes and production",
		conversionRule: "Conversion Rule",
		hasProductionRule: "Do you have a technical sheet?",
		actions: "Actions",
		clickToEdit: "Click to edit",
		sku: "SKU",
		yieldPercentage: "Yield",
		links: "Products and inputs link",
		stocks: "Stocks",
	},
	supplyActionModal: {
		title: {
			supply: "Supply links",
			stock: "Stock links",
		},
		description: {
			supply: "List of records to which this item is linked",
			stock: "List of stocks where the product is present",
		},
		seeProductButton: "See product",
		seeStockButton: "See stock",
	},
	deleteWarning: "Are you sure you want to delete this item?",
	addSupplies: "Add input",
	editSupplies: "Edit input",
	importSupplies: "Import inputs",
	exportToExcel: "Export to excel",
	addSuppliesModal: {
		name: "Name",
		unitMeasure: "Unit of measurement",
		units: "Units",
		errorMessage: "This field is mandatory",
		yieldPercentage: "Yield",
	},
	suppliesErrorsTableColumns: {
		supply: "Supply",
		error: "Error",
	},
	importModal: {
		title: "Import input",
		sheetFileName: "Inputs",
		conclude: "Conclude",
		buttonText: "Choose a worksheet",
	},
	step: {
		supply: "Supply",
		ingredients: "Ingredients",
	},
	addInputModal: {
		title: "Add supply",
		supply: "Supply or product",
		name: "Name",
		placeholderName: "Enter the name of the supply",
		sku: "SKU",
		placeholderSKU: "Enter the SKU",
		image: "Photo",
		descriptionImage: "Square image or 500x500 pixels",
		yieldPercentage: "Yield",
		basicStorageUnit: "Stock controlled by",
		placeholderBasicStorageUnit: "Enter the unit of measure",
		aboutIngredients: "About ingredients",
		ingredientsInfo:
			"Fill in the ingredient fields only if the product is a recipe that uses other supplies. For example, tomato sauce needs ingredients, but tomato does not.",
		selectInput: "Select a supply or product",
		quantity: "Quantity",
		loss: "Loss",
		addIngredient: "Add ingredient",
	},

	productRule: {
		title: "Datasheet - {{productName}}",
		generatedQuantity: "Generated quantity",
		tooltipMessage:
			"To change the amount generated, it is necessary to remove the data sheet and create it again.",
		form: {
			product: "Product",
			quantity: "The amount",
			loss: "Loss",
		},
		addAnotherSupply: "Add another input",
		hasProductionRuleError:
			"Attention, this data sheet is in error. Remove the datasheet and add it again.",
		warnings: {
			emptySupplies: "Select an input",
			emptyQuantity: "Add the amount of input",
			repeatEntry: "You added repeated inputs",
		},
	},
	cancel: "Cancel",
	conclude: "Conclude",
	erase: "Delete",
	remove: "To remove",
	yes: "Yes",
	no: " No",
	yesCaps: "YES",
	noCaps: "NO",
	edit: "To edit",
	delete: "Delete",
	link: "Link",
	links: "Links",
	deleteSelectedSupplies: "Delete selected supplies",
	deleteSelectedItens: "Delete selected items",
	deleteSupply: "Delete supply",
	deleteItems: "Delete items",
	importSupply: "Import supply",
	import: "Import",
	confirmDeleteMessage: {
		multiple: "You are about to exclude {{quantity}} inputs.",
		single: "You are about to exclude the input {{supply}}.",
	},
	viewRules: "See recipes",
	viewConversionRule: "See rule",
	doesNotHave: "Doeas not have",
	copiedSuccessfully: "Copied successfully",
	cannotDeleteSupply: "Cannot delete because the input is linked to other products",
	unlinkSupply: "Unlink",
	unlinkModalTitle: "Remove product links from inputs",
	unlinkSuccess: "Input(s) successfully unlinked",
	unlinkConfirmMessage: {
		single:
			"You are about to remove the link with products from the input <strong>{{supply}}</strong>. Products with a technical sheet will lose what was registered until now.",
		multiple:
			"You are about to remove the link with products from {{quantity}} inputs. Products with a technical sheet will lose what was registered until now.",
	},
	unlinkConfirmQuestion: "Are you sure you want to continue?",
	unlinkButtonText: "Remove input links",
	unlinkingMessage: "<strong>We are removing the links from the inputs....</strong>",
	deleteModalWithLinksMessage:
		"{{linkedCount}} of these inputs are linked to registered products, and it is not possible to delete them while these links exist. Before proceeding with the deletion, remove the links of the inputs with the products.",
	deleteModalAttention:
		"<strong>Attention: products with a technical sheet will lose the registered information until now.</strong>",
	unlinkSuccessInModal: {
		single: "The link of 1 input was successfully removed.",
		multiple: "The links of {{count}} inputs were successfully removed.",
	},
	confirmDeleteAfterUnlink: {
		single:
			"By confirming this action, the input <strong>{{supply}}</strong> will be permanently deleted. Do you wish to continue?",
		multiple:
			"By confirming this action, <strong>{{quantity}} inputs will be permanently deleted.</strong> Do you wish to continue?",
	},
	deleteModalQuestion: "",
	goBack: "Go Back",
	deleteSupplies: "Delete inputs",
};
